import { Pencil, Trash2, Receipt } from "lucide-react";
import { formatTL } from "../lib/api";
import { getCatMeta } from "../lib/categoryMeta";

export default function TransactionItem({ tx, compact, meta, onEdit, onDelete, onViewReceipt }) {
  const isIncome = tx.type === "income";
  const { Icon, color } = getCatMeta(meta, tx.category, tx.type);
  const dateStr = new Date(tx.date + "T00:00:00").toLocaleDateString("tr-TR", { day: "numeric", month: "short" });

  return (
    <div data-testid={`transaction-item-${tx.id}`}
      className="flex items-center gap-3 p-3 rounded-xl hover:bg-secondary/50 transition-colors group">
      <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: `${color}26` }}>
        <Icon className="w-4 h-4" style={{ color }} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5">
          <p className="text-sm font-medium truncate">{tx.category}</p>
          {tx.created_by_name && (
            <span data-testid={`tx-owner-${tx.id}`} title={`Ekleyen: ${tx.created_by_name}`}
              className="text-[10px] bg-secondary/70 text-muted-foreground rounded-full px-1.5 py-0.5 shrink-0">
              {tx.created_by_name.split(" ")[0]}
            </span>
          )}
          {tx.receipt_id && onViewReceipt && (
            <button data-testid={`view-receipt-${tx.id}`} onClick={() => onViewReceipt(tx)}
              title="Fişi görüntüle"
              className="p-0.5 text-primary hover:text-accent transition-colors shrink-0">
              <Receipt className="w-3.5 h-3.5" />
            </button>
          )}
        </div>
        <p className="text-xs text-muted-foreground truncate">{tx.description || dateStr}</p>
      </div>
      <div className="text-right shrink-0">
        <p className={`text-sm font-semibold ${isIncome ? "text-emerald-400" : "text-red-400"}`}>
          {isIncome ? "+" : "-"}{formatTL(tx.amount)}
        </p>
        <p className="text-xs text-muted-foreground">{dateStr}</p>
      </div>
      {!compact && (onEdit || onDelete) && (
        <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity shrink-0">
          {onEdit && (
          <button data-testid={`edit-transaction-${tx.id}`} onClick={() => onEdit(tx)}
            className="p-2 rounded-lg hover:bg-secondary text-muted-foreground hover:text-primary transition-colors">
            <Pencil className="w-4 h-4" />
          </button>
          )}
          {onDelete && (
          <button data-testid={`delete-transaction-${tx.id}`} onClick={() => onDelete(tx)}
            className="p-2 rounded-lg hover:bg-secondary text-muted-foreground hover:text-red-400 transition-colors">
            <Trash2 className="w-4 h-4" />
          </button>
          )}
        </div>
      )}
    </div>
  );
}
